export const GET_SURVEY_SUCCESS = 'GET_SURVEY_SUCCESS';
export const UPDATE_SURVEY_ITEM = 'UPDATE_SURVEY_ITEM';
export const RESET_SURVEY_ITEM = 'RESET_SURVEY_ITEM';
export const MAKE_SURVEY_NEW_SUCCESS = 'MAKE_SURVEY_NEW_SUCCESS';
export const CHECK_SURVEY_HAS_POSTED_SUCCESS = 'CHECK_SURVEY_HAS_POSTED_SUCCESS';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
